// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__17x2O","checkboxCol":"Table_checkboxCol__33IgB","emailCol":"Table_emailCol__UPBOW","actionCol":"Table_actionCol__1UUz2"};